import { DateDisplay } from '../../../index';
import React from 'react';
import { RouteLocation } from 'types/common.consts';
import _first from 'lodash/first';
import _last from 'lodash/last';

interface Props {
	routeLocations: RouteLocation[];
	timeFormat: string;
	timeZone?: string;
}

const MapboxRouteTrackerTimes: React.FC<Props> = ({ routeLocations: route, timeFormat, timeZone }) => {
	return (
		<div className="mapbox-route-tracker-times">
			<DateDisplay
				className="mapbox-route-tracker-start-time"
				date={new Date(_first(route)?.happened_at)}
				format={timeFormat}
				timezone={timeZone}
			/>
			<DateDisplay
				className="mapbox-route-tracker-end-time"
				date={new Date(_last(route)?.happened_at)}
				format={timeFormat}
				timezone={timeZone}
			/>
		</div>
	);
};

export default MapboxRouteTrackerTimes;
